import { Component, OnInit, Inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { BaseComponent } from '../../base/base.component';
import { WizardService } from '../../../services/wizard/wizard.service';
import { EventService } from '../../../services/event/event.service';
import { UtilsService } from 'common-lib/services';

import { IWizardOptions } from '../../../models';

declare var $: any;
import * as _ from 'lodash';

/**
 * Duration's values are determined by Wizard DefaultOptions
 */
@Component({
    selector: 'wizard-duration',
    templateUrl: './duration.component.html',
    styleUrls: ['./duration.component.scss', '../../form-styles.scss']
})
export class DurationComponent extends BaseComponent implements OnInit {
    public isLoading = false;
    public isPlugin = false;
    private selectedDuration = 60;
    private durations = [30, 60, 90];
    private defaultOptionsSubscription: Subscription;

    constructor(
        private wizardService: WizardService,
        private eventService: EventService,
        @Inject(UtilsService) private utilsService: UtilsService
    ) {
        super();
    }

    ngOnInit() {
        this.isPlugin = this.wizardService.config.isPlugin;
        this.durations = this.utilsService.createDurations();
        this.subscribeToMeetingDefaultsUpdates();
        this.restoreDurationIfExists();
        this.initDuration();
    }

    ngOnDestroy() {
        this.defaultOptionsSubscription.unsubscribe();
    }

    subscribeToMeetingDefaultsUpdates() {
        this.defaultOptionsSubscription = this.wizardService.onNewDefaultOptions$
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe((defaults: IWizardOptions) => {
                if (defaults) {
                    this.setNewDuration(defaults.meetingLength);
                }
            });
    }

    restoreDurationIfExists() {
        if (this.wizardService.options.meetingLength) {
            this.selectedDuration = this.wizardService.options.meetingLength;
        }
    }

    setNewDuration(meetingLength: number) {
        this.selectedDuration = meetingLength;
        this.wizardService.updateOptions({ meetingLength });
        $('#duration').dropdown('change values', this.getDurationValues());
    }

    getDurationValues() {
        return this.durations.map((duration) => {
            const hours = Math.floor(duration / 60);
            const minutes = duration % 60;
            const hourString = hours ? `${hours} ${hours > 1 ? 'hours' : 'hour'}` : undefined;
            const minuteString = minutes ? `${minutes} mins` : undefined;
            const templateString = [hourString, minuteString].filter((val) => val).join(' ');

            return {
                name: templateString,
                value: duration,
                selected: this.selectedDuration == duration
            };
        });
    }

    initDuration() {
        if (!this.selectedDuration) {
            this.isLoading = true;
        }

        $('#duration').dropdown({
            values: this.getDurationValues(),
            onChange: (value) => {
                this.wizardService.updateOptions({ meetingLength: _.toNumber(value) });
                this.eventService.clearErrorMessage('availability');
            }
        });
    }
}
